export class Manager {
  managerId : number;
  managerName : string;
}
